module.exports = __webpack_public_path__ + "static/truck_on_overpass-23aa58bb24cfb247605c8dc5cd6f748b.jpg";